import { ReactNode, useEffect, useRef } from 'react';

import { CatchWithToast, createCatchWithToast, getActiveToastRef, NotificationContext, setActiveToastRef, ToastButton } from 'app/notifications/context';
import GMetrixToast from 'components/GMetrixToast/GMetrixToast';
import { Variant } from 'react-bootstrap/esm/types';

export type NotificationContextValue = {
    catchWithToast: CatchWithToast;
    clearAllToasts: () => void;
    createToast: (message: ReactNode, variant: Variant, closeTimeout?: number, button?: ToastButton) => void;
    onErrorToast: (message: string) => void;
    onSuccessToast: (message: string) => void;
};

type NotificationProps = {
    children: ReactNode;
};

export const NotificationContextProvider = (props: NotificationProps) => {

    const { children } = props;

    const gmetrixToastRef = useRef<any>();

    useEffect(() => {

        setActiveToastRef(gmetrixToastRef);

        return () => {

            if (getActiveToastRef() === gmetrixToastRef) setActiveToastRef(null);

        };

    }, []);

    const createToast = (message: ReactNode, variant: Variant, closeTimeout?: number, button?: ToastButton) => {

        gmetrixToastRef.current?.createToast(message, variant, closeTimeout, button);

    };

    const clearAllToasts = () => {

        gmetrixToastRef.current?.clearAllToasts();

    };

    const onSuccessToast = (message: string) => {

        gmetrixToastRef.current?.createToast(message, 'success');

    };

    const onErrorToast = (message: string) => {

        gmetrixToastRef.current?.createToast(message, 'danger');

    };

    const catchWithToast = createCatchWithToast((message: string) => {

        gmetrixToastRef.current?.createToast(message, 'danger');

    });

    return (
        <NotificationContext.Provider
            value={{
                catchWithToast,
                clearAllToasts,
                createToast,
                onErrorToast,
                onSuccessToast
            }}
        >
            <GMetrixToast ref={gmetrixToastRef} />

            {children}
        </NotificationContext.Provider>

    );

};